
import "vant/es/toast/style";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./config/router";
import suroc from './suroc'
import "./style/index.less";
import { Toast } from "vant";
import 'vant/lib/index.css';

const app = createApp(App)
app.use(Toast);
app.use(suroc)
app.use(router)
app.mount("#app");